import { AppRoutes } from "@/routes/config";
import { useEffect } from "react";

const Home = () => {
  useEffect(() => {
    location.href = AppRoutes.duringContractList;
  }, []);
  return <></>;
};

export default Home;
